<template>
  <LoginBar v-if="!currentUser" />
  <AppointmentBar v-else />
</template>

<script>
import { mapState } from 'vuex'
import AppointmentBar from '@/components/navbars/AppointmentBar.vue'
import LoginBar from '@/components/authentication/LoginBar.vue'

export default {
  components: { LoginBar, AppointmentBar },

  computed: {
    ...mapState('auth', ['currentUser'])
  }
}
</script>

<style lang="scss" scoped>
.nav-auth-container {
  position: absolute;
  right: 0;
}
</style>
